import { createAction } from '@reduxjs/toolkit';
import { DemoViewMode } from '../types/DemoViewMode';

export const setDemoViewMode = createAction<DemoViewMode, 'SET_DEMO_VIEW_MODE'>('SET_DEMO_VIEW_MODE');
